import React, { Component } from "react";
import PropTypes from "prop-types";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";

// styles
import styles from "./styles";

class RendTableRow extends Component {
  static propTypes = {
    classes: PropTypes.object,
    children: PropTypes.any,
  };

  render() {
    const { children } = this.props;

    return <TableRow>{children}</TableRow>;
  }
}

export default withStyles(styles)(RendTableRow);
